/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { ModelConfig } from '@ink-ai/portal/common/Configuration/ModelConfig';
import { RootState } from '@ink-ai/portal/reducers';
import {
  getUserConfiguration,
  upsertUserConfiguration,
} from '@ink-ai/portal/reducers/configuration';
import { LoadingButton, TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Container, LinearProgress, Paper, Tab } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { PaperCard } from '../../components/Common';

export const Settings = () => {
  const [tab, SetTab] = React.useState('0');
  const dispatch = useDispatch<any>();
  const configurationState = useSelector(
    (state: RootState) => state.configuration,
  );
  useEffect(() => {
    dispatch(getUserConfiguration());
  }, []);
  const { t } = useTranslation();

  return (
    <Container maxWidth="lg" sx={{ mt: 1, mb: 1 }} className="text-left">
      {configurationState.loading ? (
        <Box sx={{ width: '100%' }}>
          <LinearProgress />
        </Box>
      ) : (
        <PaperCard>
          <TabContext value={tab}>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                paddingLeft: '16px',
              }}
            >
              <TabList
                onChange={(_, v) => SetTab(v)}
                aria-label="basic tabs example"
              >
                <Tab
                  label={t('modelConfig.title')}
                  value="0"
                  style={{
                    textTransform: 'capitalize',
                    fontWeight: 'bold',
                    fontSize: '16px',
                  }}
                />
              </TabList>
            </Box>
            <TabPanel value="0">
              <ModelConfig />
            </TabPanel>
          </TabContext>
          <Box sx={{ height: '43px' }} />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-start',
            }}
          >
            <LoadingButton
              variant="contained"
              color="primary"
              onClick={() => dispatch(upsertUserConfiguration())}
              disabled={configurationState.loading}
              sx={{ width: '99px' }}
              loading={configurationState.loading}
            >
              Save
            </LoadingButton>
          </Box>
        </PaperCard>
      )}
    </Container>
  );
};
